import {Flex, Title} from '@mantine/core'
import {ManageSubscriptionButton} from './components/ManageSubscriptionButton.tsx'
import {SubscriptionsTable} from './SubscriptionsTable.tsx'
import {StripeProvider} from '../../providers/stripe/StripeProvider.tsx'

export const SubscriptionsScreen = () => {
  return (
    <StripeProvider>
      <div style={{display: 'flex', justifyContent: 'center'}}>
        <div style={{flex: 1, display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 800}}>
          <Flex justify={'space-between'}>
            <Title order={3}>Subscription</Title>
            <ManageSubscriptionButton disabled={false} />
          </Flex>

          <SubscriptionsTable disabled={false} />
        </div>
      </div>
    </StripeProvider>
  )
}
